// extracted by mini-css-extract-plugin
export default {"ErrorWrapper":"errorPage_ErrorWrapper__OANWV","Image":"errorPage_Image__sRQhH","Title":"errorPage_Title__mfx59","Message":"errorPage_Message__hKlK8"};